<template>
	<div
		v-if="item"
		class="g-header-video-preview"
		:class="[
			`is-layout-${layout}`,
			{ 'is-h5': h5, 'is-playing': isPlaying },
		]"
	>
		<template v-if="layout === 'inline'">
			<video
				ref="videoEl"
				class="g-header-video-preview__player"
				:src="mediaSrc"
				controls
				preload="metadata"
				@loadedmetadata="onLoadedMetadata"
				@play="onPlay"
				@pause="onPause"
				@ended="onEnded"
			></video>
		</template>

		<template v-else>
			<div class="g-header-video-preview__card">
				<div
					v-if="!h5 || !isPlaying"
					class="g-header-video-preview__header"
				>
					<span class="g-header-video-preview__name">{{ displayName }}</span>
					<span
						v-if="showEditIcon"
						class="g-header-video-preview__edit mbm-iconfont mbm-bianji"
						@click.stop="$emit('edit')"
					></span>
				</div>

				<video
					ref="videoEl"
					class="g-header-video-preview__media"
					:src="mediaSrc"
					:controls="h5"
					preload="metadata"
					playsinline
					webkit-playsinline
					@loadedmetadata="onLoadedMetadata"
					@play="onPlay"
					@pause="onPause"
					@ended="onEnded"
					@click.stop="onMediaClick"
				></video>

				<button
					v-if="!isPlaying"
					type="button"
					class="g-header-video-preview__play"
					aria-label="播放"
					@click.stop="togglePlay"
				>
					<span class="g-header-video-preview__triangle"></span>
				</button>

				<span
					v-if="!h5 || !isPlaying"
					class="g-header-video-preview__duration"
				>{{ durationText }}</span>
			</div>
		</template>
	</div>
</template>

<script>
	import baseFunc from '../../config/base_func.js';
	import { formatVideoDuration } from '../utils/localVideo.js';
	import { getMediaItemUrl } from '../utils/qiniuMedia.js';

	export default {
		name: 'GHeaderVideoPreview',
		props: {
			item: {
				type: Object,
				default: null,
			},
			title: {
				type: String,
				default: '',
			},
			layout: {
				type: String,
				default: 'card',
			},
			h5: {
				type: Boolean,
				default: false,
			},
			showEditIcon: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['edit'],
		data() {
			return {
				isPlaying: false,
				duration: 0,
				hasRequestedPermission: false,
			};
		},
		computed: {
			displayName() {
				return this.title || this.item?.filename || '';
			},
			durationText() {
				if (this.duration) {
					return formatVideoDuration(this.duration);
				}
				return this.item?.durationText || '00:00';
			},
			mediaSrc() {
				var a= getMediaItemUrl(this.item)
				return getMediaItemUrl(this.item);
			},
		},
		watch: {
			item: {
				handler() {
					this.resetPlayer();
				},
				deep: true,
			},
		},
		beforeUnmount() {
			this.pauseVideo();
		},
		methods: {
			resetPlayer() {
				this.pauseVideo();
				this.duration = this.item?.duration || 0;
			},
			onLoadedMetadata() {
				const video = this.$refs.videoEl;
				if (!video) return;
				this.duration = Number.isFinite(video.duration) ? Math.floor(video.duration) : (this.item?.duration || 0);
			},
			onPlay() {
				this.isPlaying = true;
			},
			onPause() {
				this.isPlaying = false;
			},
			onEnded() {
				this.isPlaying = false;
				const video = this.$refs.videoEl;
				if (video) {
					video.currentTime = 0;
				}
			},
			onMediaClick() {
				// H5 使用原生控件；编辑区点击画面切换播放
				if (this.h5) return;
				this.togglePlay();
			},
			togglePlay() {
				const video = this.$refs.videoEl;
				if (!video || !this.mediaSrc) return;
				if (video.paused) {
					if (this.h5 && this.item?.id && !this.hasRequestedPermission) {
						this.hasRequestedPermission = true;
						this.requestPlayPermission().then(res => {
							
							this.$refs.videoEl.play().catch(() => {});
						}).catch(err => {
							this.hasRequestedPermission = false;
							this.$refs.videoEl.pause();
							this.$message.error(err.data?.message || '请求失败');
						});
					} else {
						video.play().catch(() => {});
					}
					return;
				}
				video.pause();
			},
			//访问路径中取指定的值
			getQueryStringByChannel(name) {
				const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
				if (!window.location.href.split('?')[1]) {
					return null
				}
				const re = window.location.href.split('?')[1].match(reg)
				if (re != null) return unescape(re[2])
				return null
			},
			requestPlayPermission() {
				return this.$apiRequest.post('/api/getMediaPlayPermissions', {
					attach_id: this.item.id,
					id_key: this.idKey,
					unique: '',
					p_key: this.getQueryStringByChannel('p_key')==null?'':this.getQueryStringByChannel('p_key'),
				}).then(res => {
					if (res.data?.play_url) {
						this.$refs.videoEl.src = baseFunc.getQiniusign(res.data.play_url);
					}
				});
			},
			pauseVideo() {
				const video = this.$refs.videoEl;
				if (video && !video.paused) {
					video.pause();
				}
				this.isPlaying = false;
			},
		},
	};
</script>

<style scoped lang="less">
	.g-header-video-preview {
		width: 100%;
		box-sizing: border-box;
	}

	.g-header-video-preview__player {
		display: block;
		width: 100%;
		max-height: 360px;
		background: #000;
		border-radius: 4px;
	}

	.g-header-video-preview__card {
		position: relative;
		min-height: 180px;
		background: #4d4d4d;
		overflow: hidden;
	}

	.is-h5 .g-header-video-preview__card {
		min-height: 3.6rem;
	}

	.g-header-video-preview__header {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 2;
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 10px 12px;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 100%);
	}

	.is-h5 .g-header-video-preview__header {
		padding: 0.2rem 0.24rem;
		gap: 0.12rem;
	}

	.g-header-video-preview__name {
		flex: 1;
		min-width: 0;
		font-size: 13px;
		color: #fff;
		line-height: 1.4;
		word-break: break-all;
	}

	.is-h5 .g-header-video-preview__name {
		font-size: 0.26rem;
	}

	.g-header-video-preview__edit {
		flex-shrink: 0;
		font-size: 14px;
		color: #fff;
		cursor: pointer;
		line-height: 1;

		&:hover {
			opacity: 0.85;
		}
	}

	.is-h5 .g-header-video-preview__edit {
		font-size: 0.28rem;
	}

	.g-header-video-preview__media {
		display: block;
		width: 100%;
		max-height: 280px;
		margin: 0 auto;
		object-fit: contain;
		background: #4d4d4d;
	}

	.is-h5 .g-header-video-preview__media {
		max-height: 5.6rem;
	}

	.g-header-video-preview__play {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 56px;
		height: 56px;
		margin: -28px 0 0 -28px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.92);
		cursor: pointer;
		outline: none;
	}

	.is-h5 .g-header-video-preview__play {
		width: 1.12rem;
		height: 1.12rem;
		margin: -0.56rem 0 0 -0.56rem;
	}

	.g-header-video-preview__triangle {
		display: block;
		width: 0;
		height: 0;
		margin-left: 4px;
		border-top: 9px solid transparent;
		border-bottom: 9px solid transparent;
		border-left: 14px solid #333;
	}

	.is-h5 .g-header-video-preview__triangle {
		margin-left: 0.08rem;
		border-top-width: 0.18rem;
		border-bottom-width: 0.18rem;
		border-left-width: 0.28rem;
	}

	.g-header-video-preview__duration {
		position: absolute;
		right: 10px;
		bottom: 8px;
		z-index: 2;
		font-size: 12px;
		color: #fff;
		line-height: 1.4;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
	}

	.is-h5 .g-header-video-preview__duration {
		right: 0.2rem;
		bottom: 0.16rem;
		font-size: 0.24rem;
	}
</style>
